import {EffectivePromoPhotoResponseBody} from '@dms/api/vehicle';

import {UnifiedAlbumImage} from '../types/UnifiedAlbumImage';

export type SyncedCampaignPromoPhoto = EffectivePromoPhotoResponseBody & {
  url: string;
  remoteFileId: string;
};

export const toUnifiedCampaignPromoPhoto = (
  photo: SyncedCampaignPromoPhoto
): UnifiedAlbumImage => ({
  id: photo.fileId,
  fileId: photo.fileId,
  remoteFileId: photo.remoteFileId,
  url: photo.url,
  latestFileOperation: null,
  weight: photo.position,
  position: photo.position,
  isCoverPhoto: false,
  isPromoPhoto: true,
  isCampaignPhoto: true,
});
